export function timeslotTimes(timeslot, availability = [], maxCapacity = 0, isDateToday = false, bookedTimes = {}) {
    let startSplit = timeslot.start.split(":");
    let endSplit = timeslot.end.split(":");
    let startTime = Number(startSplit[0]) * 60 + Number(startSplit[1]);
    let interval = timeslot.intervals || 10;
    let duration = timeslot.duration || timeslot.time || 60;
    if (isDateToday) {
        const now = new Date();
        let nowTime = now.getHours() * 60 + now.getMinutes();
        if (nowTime > startTime) {
            while (startTime < nowTime) {
                startTime += interval;
            }
        }
    }
    let endTime = Number(endSplit[0]) * 60 + Number(endSplit[1]);
    let times = [];

    const hasTimeslotLimit = timeslot.maxPeople !== null && timeslot.maxPeople !== undefined;

    for (let i = startTime; i < endTime; i += interval) {
        if (i + duration > endTime) break;
        let hour = Math.floor(i / 60);
        let minute = i % 60;
        let timeStr = hour.toString().padStart(2, "0") + ":" + minute.toString().padStart(2, "0");
        let available = maxCapacity;
        for (let seg of availability) {
            let segStartParts = seg.start.split(":");
            let segEndParts = seg.end.split(":");
            let segStart = Number(segStartParts[0]) * 60 + Number(segStartParts[1]);
            let segEnd = Number(segEndParts[0]) * 60 + Number(segEndParts[1]);
            if (i < segEnd && (i + duration) > segStart) {
                // seg.available is based on table capacity: maxCapacity - overlapping booked people
                available = Math.min(available, seg.available);
                if (available <= 0) {
                    available = 0;
                    break;
                }
            }
        }
        // max_people limits each bookable time independently: only reservations
        // starting exactly at this time count against it
        if (hasTimeslotLimit) {
            let bookedAtTime = bookedTimes[timeStr] || 0;
            available = Math.min(available, Math.max(timeslot.maxPeople - bookedAtTime, 0));
        }
        times.push({ available, time: timeStr });
    }
    return times;
}
